import { render, staticRenderFns } from "./NewOrder.vue?vue&type=template&id=4f79183c&scoped=true&"
import script from "./NewOrder.vue?vue&type=script&lang=js&"
export * from "./NewOrder.vue?vue&type=script&lang=js&"
import style0 from "./NewOrder.scss?vue&type=style&index=0&id=4f79183c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../home/gitlab-runner/.nvm/versions/node/v12.14.1/lib/node_modules/@briskly/vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f79183c",
  null
  
)

export default component.exports